import {Skills} from '../enums';

/** навыки ссылаются на статью глоссария: `{@skill perception, Внимание} +26` */
export function toMonsterSkills(skills: Array<{type: string; value: string}>) {
	return skills
		.map((skill) => ({title: Skills[skill.type], text: `{@skill ${skill.type}, ${Skills[skill.type]}} ${skill.value}`}))
		.sort((first, second) => first.title.localeCompare(second.title, 'ru'))
		.map((skill) => skill.text)
		.join(', ');
}
